import moment from "moment";

export const status = {
  published: "PUBLISHED",
  locked: "LOCKED",
  unlocked: "UNLOCKED",
  confirmed: "CONFIRMED",
  ["Pending Confirmation"]: "PENDING",
  ["Published to EHR"]: "PUBLISHED",
};

// export const appointmentStatuses = [
//   "All",
//   status["Published to EHR"],
//   status.locked,
//   status.confirmed,
//   status["Pending Confirmation"]
// ];
export const appointmentStatuses = [
  { name: "All" },
  { name: "Pending Confirmation", value: status["Pending Confirmation"] },
  { name: "Locked", value: status.locked },
  { name: "confirmed", value: status.confirmed },
  { name: "Published to EHR", value: status["Published to EHR"] },
  { name: "unlocked", value: status["unlocked"] },
];

export const locationTypes = [
  {
    id: "All",
    name: "All",
  },
  {
    id: "PRIVATE_HOME",
    name: "Private Home",
  },
  {
    id: "COMMUNITY_HOME",
    name: "Community",
  },
];

export function capitalize(string) {
  const str_arr = string.split(" ");

  for (let i = 0; i < str_arr.length; i++) {
    str_arr[i] = str_arr[i][0].toUpperCase() + str_arr[i].slice(1);
  }
  return str_arr.join(" ");
}

export const getSummaryText = (scheduleData, selectedAction, targetDate) => {
  if (!selectedAction) {
    return null;
  }
  const formattedDate = targetDate
    ? moment(targetDate).format("dddd, MMMM DD")
    : "[Select a date]";

  const originalDateFormatted = scheduleData?.date
    ? moment(scheduleData.date).format("dddd, MMMM DD")
    : "[Select a date]";

  const normalCount = scheduleData?.appointments?.filter(appointment => appointment.status !== "PUBLISHED").length;
  const lockedCount = scheduleData?.appointments?.filter(appointment => appointment.status === "UNLOCKED").length;
  const unlockedCount = scheduleData?.appointments?.filter(appointment => appointment.status === "LOCKED").length;
  const count = scheduleData?.appointments?.length;

  const actionDetailsMap = {
    reschedule: {
      verb: "Reschedule",
      conjunction: "from",
      conjunction2: "to",
      sourceInfo: originalDateFormatted,
      targetInfo: formattedDate,
      details:
        "Original appointments will be removed and recreated on the selected date with the same times.",
        count: normalCount,
    },
    copy: {
      verb: "Copy",
      conjunction: "from",
      conjunction2: "to",
      sourceInfo: originalDateFormatted,
      targetInfo: formattedDate,
      details:
        "Original appointments will remain unchanged. New appointments will be created on the selected date.",
        count: count,
    },
    lock: {
      verb: "Lock",
      conjunction: "on",
      conjunction2: null,
      sourceInfo: originalDateFormatted,
      targetInfo: null,
      details:
        "These appointments will be protected from changes until manually unlocked. Patients can still view them.",
        count: lockedCount,
    },
    unlock: {
      verb: "Unlock",
      conjunction: "on",
      conjunction2: null,
      sourceInfo: originalDateFormatted,
      targetInfo: null,
      details: "These appointments will be unlocked and can be changed.",
      count: unlockedCount,
    },
    cancel: {
      verb: "Cancel",
      conjunction: "on",
      conjunction2: null,
      sourceInfo: originalDateFormatted,
      targetInfo: null,
      details:
        "All appointments will be permanently cancelled. Consider notifying patients before proceeding.",
        count: count,
    },
  };

  const selectedActionDetail = actionDetailsMap[selectedAction];

  return selectedActionDetail || null;
};

export const getActionOptions = (isLocked) => [
  {
    id: "reschedule",
    label: "Reschedule",
    icon: "📅",
    description: "Move all appointments to a new date",
  },
  {
    id: "copy",
    label: "Copy",
    icon: "📋",
    description: "Duplicate appointments to another date",
  },
  isLocked
    ? {
        id: "unlock",
        label: "Unlock",
        icon: "🔓",
        description: "Unlock all appointments",
      }
    : {
        id: "lock",
        label: "Lock",
        icon: "🔒",
        description: "Prevent changes to all appointments",
      },
  {
    id: "cancel",
    label: "Cancel",
    icon: "❌",
    description: "Cancel all appointments for this day",
  },
];
